import { ViewportScroller, Location } from "@angular/common";
import { Component, HostListener, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { debounceTime, Subscription } from "rxjs";
import { API_ROUTES } from "src/app/core/_constants/api-route.constant";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { EditEnquiryComponent } from "src/app/modules/pages/profile/edit-enquiry/edit-enquiry.component";
import { ApiServicesService } from "src/app/services/apiServices/api-services.service";
import { CommonService } from "src/app/services/common.service";
import { DataService } from "src/app/services/data.service";
import { SearchService } from "src/app/services/search.service";
import { LocalStorageProvider } from "src/app/services/storage/storage.service";
import { FilterProductComponent } from "src/app/shared/dialogs/filter-product/filter-product.component";


@Component({
  selector: 'app-product-listing',
  templateUrl: './product-listing.component.html',
  styleUrls: ['./product-listing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductListingComponent implements OnInit {

  products: any[] = [];
  industryName: string;
  industriess: string[] = [];
  selectedIndustriess: { [key: string]: boolean } = {};
  allCategories: any[] = [];
  filteredResultss: any[] = [];
  selectedIndustry: any = null;
  selectedIndustry1: any[] = [];
  filtered: any[];
  requirementsPost: any;
  domUrls: string;
  selectedIndustryId: number;
  selectedIndustryId1: number;
  size: any = 20;
  allProducts: any[] = [];
  selectedSortOption: string = 'recent';
  pageSize: number = 20;
  currentPage: number = 1;
  pages: number[] = [];
  params: any = {};
  categoryTitleName: any;
  selectedIndustries: { [key: string]: boolean } = {};
  isToggled: boolean = false;
  filteredResults: any;
  combinedSubcategories: any[];
  alldata: any;
  totalPages: number;
  isInablePagination: boolean = false
  toggle() {
    this.isToggled = !this.isToggled;
  }
  get Math() {
    return Math;
  }
  list: any = [];
  noDataFound: boolean = false;
  sortby: any;
  filterData: any;
  sortedObject: { sortby: any };
  page: number = 1;
  Size: number = 20;
  count: number = 0;
  search: string;
  deviceInfo = this.deviceService.getDeviceInfo();
  subscription: Subscription;
  guestUser: string | null;
  filterAPIData: any;
  scrolledBottom: boolean = false;
  RouteConstant: any = RouteConstant;
  productDetailScreen: any =
    "/" +
    RouteConstant.main +
    "/" +
    RouteConstant.marketPlaceList +
    "/" +
    RouteConstant.marketplaceProductDetail;
  filter: any;
  noProductsFound: boolean = false;
  Searchresults: any[] = [];
  industry: any[] = [];
  AllSubCategory1: any[] = [];
  AllSubCategory2: any[] = [];
  AllSubCategory3: any[] = [];
  AllBrandList: any[] = [];
  selectedParams: any = {
    industryId: null,
    subCategory1Id: null,
    subCategory2Id: null,
    subCategory3Id: null,
    brand_id: null,
    job_type: null,
  };
  jobTypes: any[] = [{
    name: 'Job work seeker'
  },{
    name: 'Jobwork out source'
  }];
  job_work_id: any ='31dcdb22-05c4-4a27-8481-3afbee03e8d4';
  itemsPerPage: number = 10; 
  totalCount: number = 0; 
  remainingCount: number = 0; 
  isPaginationEnabled: boolean = false;
  constructor(
    private loader: NgxUiLoaderService,
    private service: ApiServicesService,
    private dialog: MatDialog,
    private commonService: CommonService,
    private activeRoute: ActivatedRoute,
    private searchService: SearchService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private toastr: ToastrService,
    private storageService: LocalStorageProvider,
    private viewportScroller: ViewportScroller,
    private dataService: DataService,
    private Location: Location,
    private route: ActivatedRoute,
  ) {
    debugger
    this.domUrls = this.service.getBaseUrl();
    this.route.queryParams.subscribe(params => {
      this.selectedParams.industryId = params['industryId'];
      this.selectedParams.subCategory1Id = params['subCategory1Id'];
      this.selectedParams.subCategory2Id = params['subCategory2Id'];
      this.selectedParams.subCategory3Id = params['subCategory3Id'];
      this.selectedParams.brand_id = params['brand_id'];
      this.selectedParams.job_type = params['job_type'];
      this.selectedParams.sortType = params['sortType'];
      this.selectedParams.country_origin = params['country_origin'];
      this.selectedParams.recentlyviewed = params['recentlyviewed'];
      this.selectedParams.recommended = params['recommended'];
      if (this.selectedParams.sortType) {
        this.selectedSortOption = this.selectedParams.sortType;
        this.getProductsList(this.selectedSortOption); 
      }
      
    });
  }
  category: any;
  industry_id1: any;
  ngOnInit(): void {
    this.getProductsList(this.selectedSortOption);
    const ab = this.Location.getState()
    this.industry_id1 = this.Location.getState()
    this.dataService.searchValue$.subscribe(val => {
      if (val !== '') {
        this.search = val;
      }
    })

    this.fetchServices();
    this.resgetIndustry();
    localStorage.removeItem("url");
    this.guestUser = localStorage.getItem("guestUser");
    this.activeRoute.queryParams.subscribe((params) => {
      let industry = params?.["industry"];
      let category1 = params?.["category1"];
      this.filter = params?.["filter"];
      let obj: any;
      obj = {
        industry: industry,
        category1: category1,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] == "" || !obj[key]) {
          delete obj[key];
        }
      });
      this.filterData = obj;
    });
    if (this.filter) {
      if (localStorage.getItem("marketPlaceFilter")) {
        this.filterData = this.storageService.getItem("marketPlaceFilter");
      }
      if (localStorage.getItem("marketPlaceSort")) {
        this.sortby = this.storageService.getItem("marketPlaceSort");
      }
    } else {
      this.commonService.deleteFilterData();
    }
    this.filterAPI();
    this.subscription = this.searchService.currentMessage
      .pipe(debounceTime(500))
      .subscribe((text) => {
        this.search = text;
        this.page = 1;
        this.list = [];
      });

  }

  
  onSortChange() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sortType: this.selectedSortOption },
      queryParamsHandling: 'merge', // keep other params like industryId
    });
    
    switch (this.selectedSortOption) {
      case 'recent':
      case 'popularity':
      case 'ASC':
      case 'DESC':
       
        break;
    }
  }



   enquiry() {
      const screenWidth = window.innerWidth;
      let isSmallScreen = false;
      if (screenWidth <= 1440) {
        isSmallScreen = true;
      }
      let token = localStorage.getItem('stoken');
      if (token) {
        const dialogRef = this.dialog.open(EditEnquiryComponent, {
          maxHeight: '100vh',
          width: isSmallScreen ? '1000px' : '1000px',

        });
      }
      else {
        this.toastr.error('Need to login first');
        this.service.Login();
      }
    }
  resgetIndustry() {
    this.service.get({}, `${API_ROUTES.Account.getIndustry}`).pipe().subscribe((res) => {
      res.result.unshift({ 'id': 0, 'industry_name': 'All' });
      this.industry = res.result;


      if (this.selectedParams?.industryId) {
        this.getAllSubCategory1(this.selectedParams?.industryId)
      }
    })
  }

  industrysub: any;
  industries: { id: any, sub_category_name: any }[] = [];
  getAllSubCategory(subCategoryId: string) {
    this.service.post({ industry_id: subCategoryId }, API_ROUTES.Account.getIndustriesByCategory, '').subscribe(
      (response) => {
        if (response && Array.isArray(response.result)) {
          this.industries = [];
          response.result.forEach((item: any) => {
            this.industries.push(
              {
                id: item.id,
                sub_category_name: item.sub_category_name
              }
            );
          });
        }
      },
      (error) => {
        console.error('Error occurred while fetching industries:', error);
      }
    );
   
  }
  

  getProductsList(sortType: string) {
    window.scrollTo(0, 0);  
    const params: any = {};
    this.params = {
      pageNo: this.currentPage,
      sortType: this.selectedSortOption,
      size: 20,
    };
    if (this.selectedParams.industryId === undefined) {
      this.selectedParams.industryId = 0;
    }
    if (this.selectedParams.industryId) {
      params.industry_id = this.selectedParams.industryId;
    }
    if (this.selectedParams.sortType) {
      params.sortType = this.selectedParams.sortType;
    }
    if (this.selectedParams.country_origin) {
      params.country_origin = this.selectedParams.country_origin;
    }
    if (this.selectedParams.recentlyviewed) {
      params.recentlyviewed = this.selectedParams.recentlyviewed;
    }
    if (this.selectedParams.recommended) {
      params.recommended = this.selectedParams.recommended;
    }
  
    if (this.selectedParams.subCategory1Id) {
      params.category1_id = this.selectedParams.subCategory1Id;
    }

    if (this.selectedParams.subCategory2Id) {
      params.category2_id = this.selectedParams.subCategory2Id;
    }
    if (this.selectedParams.subCategory3Id) {
      params.category3_id = this.selectedParams.subCategory3Id;
    }
    if (this.selectedParams.brand_id) {
      params.brand_id = this.selectedParams.brand_id;
    }
    if (this.selectedParams.job_type) {
      params.job_type = this.selectedParams.job_type;
    }
    if(localStorage.getItem('UserId')){
      params.auth_id = localStorage.getItem('UserId');
    }

    Object.keys(params).forEach(key => {
      if (params[key] === undefined) {
        delete params[key];
      }
    });
    this.params = { ...this.params, ...params };
       
    this.service.get(this.params, API_ROUTES.productsList).subscribe({
      next: (response) => {
        if (response?.result && Object.keys(response.result).length > 0) {
          const products = this.getProductsFromResponse(response);
          this.Searchresults = products;
          if (products.length > 0) {
            this.noProductsFound = false; 
          } else {
            this.noProductsFound = true; 
          }

          this.totalCount = response.result.totalCount || 0;
          this.remainingCount = response.result.remainingCount || 0;
          this.calculatePagination();
        } else {
          this.handleNoResults();
        }
      },
      error: (error) => {
        console.error('Error fetching search results:', error);
        this.handleNoResults();
      },
    });
  }

  handleNoResults() {
    this.Searchresults = [];
    this.noProductsFound = true; 
    this.totalCount = 0;
    this.remainingCount = 0;
    this.isPaginationEnabled = false;
  }

  calculatePagination() {
    if (this.totalCount > 0 && this.params.size) {
      this.totalPages = Math.ceil(this.totalCount / this.params.size);
      this.isPaginationEnabled = this.totalPages > 1;
      this.updateDisplayedPages()
    } else {
      this.pages = [];
      this.isPaginationEnabled = false;
    }
  }
  rangeSize: any = 10
  updateDisplayedPages() {
  const startPage = Math.max(1, this.currentPage - Math.floor(this.rangeSize / 2)+1);
  const endPage = Math.min(this.totalPages, startPage + this.rangeSize - 1);
  const adjustedStartPage = Math.max(1, endPage - this.rangeSize + 1);
  this.pages = Array.from({ length: endPage - adjustedStartPage + 1 }, (_, i) => adjustedStartPage + i);
  }

  getProductsFromResponse(response: any): any[] {
    let products: any[] = [];
    if (response?.result) {
      Object.keys(response.result).forEach((key) => {
       if (response.result[key]?.products && response.result[key]?.products[0]?.Product) {
          response.result[key]?.products.forEach((Product: any) => {
            
              products = [...products, Product.Product]; // or skip if not valid
            
          });
        } else if (response.result[key]?.products) {
            products = [...products, ...response.result[key].products];
        }
      });
    }
    return products;
  }

  selectIndustry(industryId: any): void {
    this.currentPage = 1;
    this.AllSubCategory2.length = 0;
    this.AllSubCategory3.length = 0;
    if (this.selectedParams.industryId === industryId) {
      this.selectedParams.subCategory1Id = null;
      this.selectedParams.subCategory2Id = null;
      this.selectedParams.subCategory3Id = null;
      this.selectedParams.brand_id = null
      this.selectedParams.job_type = null
      this.AllBrandList = [];
      this.updateURLParams();
      this.getProductsList(this.selectedSortOption);

    } else {
      this.selectedParams.industryId = industryId;
      this.selectedParams.subCategory1Id = null;
      this.selectedParams.subCategory2Id = null;
      this.selectedParams.subCategory3Id = null;
      this.selectedParams.brand_id = null
      this.selectedParams.job_type = null
      this.AllBrandList = [];
      this.getAllSubCategory1(industryId);
      this.getProductsList(this.selectedSortOption);
      this.updateURLParams();
    }

  }
  get selectedIndustryName(): string {
    const selectedIndustry = this.industry.find(industry => industry.id === this.selectedParams.industryId);
    return selectedIndustry ? selectedIndustry.industry_name : 'Unknown Industry';
  }

  updateURLParams(): void {
    const queryParams: any = {};
    if (this.selectedParams.industryId) {
      queryParams.industryId = this.selectedParams.industryId;
    }
    if (this.selectedParams.subCategory1Id) {
      queryParams.subCategory1Id = this.selectedParams.subCategory1Id;
    }
    if (this.selectedParams.subCategory2Id) {
      queryParams.subCategory2Id = this.selectedParams.subCategory2Id;
    }
    if (this.selectedParams.subCategory3Id) {
      queryParams.subCategory3Id = this.selectedParams.subCategory3Id;
    }
    if (this.selectedParams.brand_id) {
      queryParams.brand_id = this.selectedParams.brand_id;
    }
    if (this.selectedParams.job_type) {
      queryParams.job_type = this.selectedParams.job_type;
    }
    const queryString = new URLSearchParams(queryParams).toString();
    const newUrl = `${window.location.pathname}?${queryString}`;
    window.history.replaceState(null, '', newUrl);
  }



  getAllSubCategory1(industryId: string): void {
    this.service.post({ industry_id: industryId }, API_ROUTES.Account.getIndustriesByCategorys, '').subscribe(
      (response) => {
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory1 = response.result.rows;
          if (this.selectedParams?.subCategory1Id) {
            this.getAllSubCategory2(this.selectedParams.subCategory1Id);
            this.getAllBrandList(this.selectedParams.subCategory1Id)
          }
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllSubCategory1 = [];
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);
        this.AllSubCategory1 = [];
        this.loader.stop(); 
      }
    );
  }

  show_product(subCategory1Id: any): void {

    if (this.selectedParams.subCategory1Id === subCategory1Id) {
      this.selectedParams.subCategory2Id = null;
      this.selectedParams.subCategory3Id = null;
      this.selectedParams.brand_id = null;
      this.selectedParams.job_type = null;
      this.updateURLParams();
      this.getProductsList(this.selectedSortOption);
      
    } else {
      this.selectedParams.subCategory1Id = subCategory1Id;
      this.selectedParams.subCategory2Id = null;
      this.selectedParams.subCategory3Id = null;
      this.selectedParams.brand_id = null;
      this.selectedParams.job_type = null;
      this.getAllBrandList(subCategory1Id);
      this.getAllSubCategory2(subCategory1Id);
      this.getProductsList(this.selectedSortOption);
      this.updateURLParams();
    }
    this.AllSubCategory3.length = 0;
  }

  getAllSubCategory2(subCategory1Id: string) {
    this.service.post({ category1_id: subCategory1Id }, API_ROUTES.Account.getCatByCategory1, '').subscribe(
      (response) => {
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory2 = response.result.rows;
          if (this.selectedParams?.subCategory2Id) {
            this.getAllSubCategory3(this.selectedParams.subCategory2Id);
          }
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllSubCategory2 = []; 
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);
        this.AllSubCategory2 = [];
        this.loader.stop();
      }
    );
  }

  getAllBrandList(subCategory1Id: string) {
    this.service.get({ category1_id: subCategory1Id }, API_ROUTES.Account.getBrand, '').subscribe(
      (response) => {
        if (response?.result && response.result.length > 0) {
          this.AllBrandList = response.result;
          // if (this.selectedParams?.subCategory2Id) {
          //   this.getAllSubCategory3(this.selectedParams.subCategory2Id);
          // }
        } else {
          console.warn('No subcategories found for the selected industry.');
          this.AllBrandList = []; 
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);
        this.AllBrandList = [];
        this.loader.stop();
      }
    );
  }

  selectSubCategory2(subCategory2Id: any): void {
    if (this.selectedParams.subCategory2Id === subCategory2Id) {
      this.selectedParams.subCategory3Id = null;

    } else {
      this.selectedParams.subCategory2Id = subCategory2Id;
      this.selectedParams.subCategory3Id = null;
      this.getAllSubCategory3(subCategory2Id)
      this.getProductsList(this.selectedSortOption);
    }

    this.updateURLParams();
  }


  getAllSubCategory3(subCategory2Id: string) {
    this.service.post({ category2_id: subCategory2Id }, API_ROUTES.Account.getCatByCategory2, '').subscribe(
      (response) => {
  
        if (response?.result?.rows && response.result.rows.length > 0) {
          this.AllSubCategory3 = response.result.rows;
        } else {
          this.AllSubCategory3 = []; 
        }
      },
      (error) => {
        console.error('Error occurred while fetching subcategories:', error);

        this.AllSubCategory3 = [];
        this.loader.stop(); 
      }
    );

  }


  selectSubCategory3(item: any): void {
    this.selectedParams.subCategory3Id = item.id;
    this.getProductsList(this.selectedSortOption);
    this.updateURLParams()
  }

  selectBrands(item: any): void {
    this.selectedParams.brand_id = item.id;
    this.updateURLParams();
    this.getProductsList(this.selectedSortOption);
  }
  selectJobType(item: any){
    this.selectedParams.job_type = item.name;
    this.updateURLParams();
    this.getProductsList(this.selectedSortOption);

  }

  fetchServices() {
    this.loader.start();
    this.allProducts = [];
    this.params.pageNo = this.currentPage;
    this.params.sortType = this.selectedSortOption;
    this.params.size = 20;
   
    const params: any = {};

    if (this.selectedParams.industryId) {
      params.industry_id = this.selectedParams.industryId;
    }

    if (this.selectedParams.subCategory1Id) {
      params.category1_id = this.selectedParams.subCategory1Id;
    }

    if (this.selectedParams.subCategory2Id) {
      params.category2_id = this.selectedParams.subCategory2Id;
    }

    Object.keys(params).forEach(key => {
      if (params[key] === undefined) {
        delete params[key];
      }
    });
    this.params = { ...this.params, ...params };



    let endpoint = API_ROUTES.productsList;

    this.service.get(this.params, endpoint).subscribe({
      next: (res: any) => {
        this.loader.stop();
        const combinedProducts: any[] = [];
        if (res.result) {
          if (this.selectedIndustry === 0) {
            Object.keys(res.result).forEach((key) => {
              const industryData = res.result[key];
              if (industryData?.subcategories) {
                Object.keys(industryData.subcategories).forEach((subCategoryKey) => {
                  const subCategory = industryData.subcategories[subCategoryKey];
                  if (subCategory?.products) {
                    combinedProducts.push(...subCategory.products);
                  }
                });
              }
            });
          } else if (this.selectedIndustry1.length > 0 && res?.result && typeof res.result === 'object') {
            Object?.keys(res?.result)?.forEach((key) => {
              const industryData = res.result[key];
              if (industryData?.subcategories && typeof industryData.subcategories === 'object') {
                Object?.keys(industryData?.subcategories)?.forEach((subCategoryKey, index) => {
                  const subCategory = industryData?.subcategories[subCategoryKey];
                  if (this.selectedIndustry1.includes(subCategory.sub_category_id)) {
                    if (subCategory?.products) {
                      combinedProducts?.push(...subCategory.products);
                    }
                  }
                });
              }
            })
          }
          else {
            Object?.keys(res.result)?.forEach((key) => {
              const industryData1 = res.result[key];
              if (industryData1?.industry_id === this.selectedIndustry) {
                Object?.keys(industryData1.subcategories)?.forEach((subCategoryKey, index) => {
                  const subCategory = industryData1?.subcategories[subCategoryKey];
                  if (subCategory?.products) {
                    combinedProducts?.push(...subCategory.products);
                  }
                });
              }

            })
          }
          this.allProducts = combinedProducts;
          this.isInablePagination = this.allProducts.length >= 20 ? true : false;
          if (this.currentPage === 1) {
          }
        } else {
          console.warn('No result found in the response.');
        }
      },
      error: (error) => {
        console.error('API Error:', error);
        this.toastr.error(error.result.error);
      }
    });
  }

  selectedIndustriesForFilter: { [industry: string]: boolean } = {};

  filterProducts(industryID: any, name?: any) {
    const isChecked = this.selectedIndustries[name];
    if (isChecked) {
      if (!this.selectedIndustry1.includes(industryID)) {
        this.selectedIndustry1.push(industryID);
      }
    } else {
      const index = this.selectedIndustry1.indexOf(industryID);
      if (index > -1) {
        this.selectedIndustry1.splice(index, 1);
      }
    }
    this.fetchServices();
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
  if (page < this.pages[0] || page > this.pages[this.pages.length - 1]) {
    this.updateDisplayedPages();
  }
  this.getProductsList(this.selectedSortOption);
  }

  generatePages() {
    this.pages = [];
    for (let i = 1; i <= this.currentPage; i++) {
      this.pages.push(i);
    }
  }
  

  viewSingleProduct(productId: string, category: string) {
    // let token = localStorage.getItem('stoken');
    // if (token) {
        this.router.navigate([RouteConstant.productdetail], { queryParams: { productId: productId } });
    // }
    // else {
    //   this.toastr.error('Need to login first');
    //   this.service.Login();
    // }
    
  }


  objectKeys(obj: object): string[] {
    return Object.keys(obj);
  }

  ShowAllServices: any = [];
  totalProducts = 0;
  
  goBack() {
    this.dataService.setSearchValue('');
    this.router.navigate([
      "/" + RouteConstant.main + "/" + RouteConstant.marketPlaceList,
    ]);
  }

  filterAPI() {
    this.service
      .get({}, API_ROUTES.MarketPlaceFilters.filters)
      .subscribe((res) => {
        if (res.success) {
          this.filterAPIData = res.result;

        }
      });
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    let pos =
      (document.documentElement.scrollTop || document.body.scrollTop) +
      document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight;
    if (pos >= max && this.scrolledBottom) {
      this.page = this.page + 1;
      this.List();
    }
  }

  List() {
    this.loader.start();
    let params: any;
    params = {
      type: "popular",
      pageNo: this.page,
      size: this.Size,
      sortby: this.sortby,
      search: this.search,
     
    };
    Object.keys(params).forEach((key) => {
      if (
        params[key] == null ||
        params[key] == "" ||
        params[key] == "default"
      ) {
        delete params[key];
      }
    });
    if (this.filterData) {
      params = { ...params, ...this.filterData };
    }
    let url;
    if (this.guestUser) {
      url = API_ROUTES.Marketplace.marketPlaceGuestList2;
    } else {
      url = API_ROUTES.Marketplace.marketPlaceList2;
    }
    this.service
      .get(params, url)
      .pipe()
      .subscribe(
        (res) => {
          this.loader.stop();
          if (res.success) {
            if (res.result && res.result.length > 0) {
              this.list = this.list.concat(res.result);
              this.noDataFound = false;
              this.list.forEach((element: any) => {
                let image = element.Media.find((item: any) =>
                  item.media_type.toLowerCase().includes("image")
                );
                
                let video = element.Media.find((item: any) =>
                  item.media_type.toLowerCase().includes("video")
                );
                if (image) {
                  element.shapeImageUrl = image.url;
                } else if (video) {
                  element.shapeImageUrl = video.thumbnail_url
                    ? video.thumbnail_url
                    : "assets/images/placeholder-img.svg";
                } else {
                  element.shapeImageUrl = "assets/images/placeholder-img.svg";
                }
              });
              this.scrolledBottom = true;
            } else if (res.result && res.result.length == 0) {
              this.scrolledBottom = false;
              this.noDataFound = this.list.length == 0 ? true : false;
            }
          } else {
          }
        },
        (error) => {
          if (error.error_code == 400) {
            this.toastr.error(error.result.error);
          }
        }
      );
  }

  filterDialog() {
    const screenWidth = window.innerWidth;
    let isSmallScreen = false;
    if (screenWidth <= 1440) {
      isSmallScreen = true;
    }

    const dialogRef = this.dialog.open(FilterProductComponent, {
      maxHeight: "100vh",
      width: isSmallScreen ? '350px' : '465px',
      panelClass: "filter",
      data: {
        sortBy: this.sortby,
        filterBy: this.filterData,
        filterData: this.filterAPIData,
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.result == true) {
        if (data.sortdata) {
          let sortFind = data.sortdata.find((el: any) => el.isSelected == true);
          if (sortFind) {
            this.sortby = sortFind.value;
          } else {
            this.sortby = null;
          }
        }
        if (data.filterdata) {
          Object.keys(data.filterdata).forEach((key) => {
            if (data.filterdata[key] == "" || data.filterdata[key] == "0") {
              delete data.filterdata[key];
            }
          });
          this.filterData = data.filterdata;
        }
        this.page = 1;
        this.Size = 20;
        this.list = [];
        this.List();
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  viewProduct(id: any) {
    localStorage.setItem("url", "product");
    if (Object.keys(this.filterData).length > 0) {
      this.storageService.setItem("marketPlaceFilter", this.filterData);
    }
    if (this.sortby) {
      this.storageService.setItem("marketPlaceSort", this.sortby);
    }
    if (this.sortby || Object.keys(this.filterData).length > 0)
      this.router.navigate(
        [
          "/" +
          RouteConstant.main +
          "/" +
          RouteConstant.marketPlaceList +
          "/" +
          RouteConstant.marketplaceProductDetail,
        ],
        {
          queryParams: {
            productId: id,
            type: 2,
            filter: true,
            category: "popular",
          },
        }
      );
    else
      this.router.navigate(
        [
          "/" +
          RouteConstant.main +
          "/" +
          RouteConstant.marketPlaceList +
          "/" +
          RouteConstant.marketplaceProductDetail,
        ],
        { queryParams: { productId: id, type: 2, category: "popular", filter: true } }
      );
  }
}
